module.exports = __webpack_public_path__ + "media/character-baby-happy.c911be1e.mp3";